// third-party
import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  colorSettings: [],
  allPopup: [],
  allRankingHistoryByID: [],
  allRanking: [],
  gameListUrl: [],
  allProvider: [],
  playerCash: [],
  bannerList: [],
  wheelSetting: [],
  wheelPoint: 0, // normalized to numeric
  friendInvite: [],
  userAvailablePromotion: [],
  withdrawSetting: [],
  bankList: [],
  transferBankList: [],
  websiteSetting: [],
  transactionHistory: [],
  transactionHistoryMeta: null,
  withdrawHistory: [],
  withdrawHistoryMeta: null,
  playerLoginLink: [],
  playerBalance: [],
  tmnData: [],
  cashbackSetting: [],
  cashback: [],
  inviteSetting: [],
  betflixStatus: [],
  totalUsers: [],
  singleUsers: [],
  agentInfo: [],
  agentBalance: [],
  singleAdmin: [],
  singlePromo: [],
  todayPromotionReceived: [],
  allPromotionReceived: [],
  allPromo: [],
  singleCreditCode: [],
  allCreditCode: [],
  todayUsers: [],
  byIdTransDW: [],
  allTransDW: [],
  allAdmin: [],
  userBalance: [],
  currentUser: null, // added for setCurrentUser / clearCurrentUser
  hotGames: [],
  hotGamesLoading: false,
  hotGamesError: null,
  marketingActivitiesActive: [],
  marketingSubmitResult: null,
};

export const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getColorSettingsSuccess(state, action) {
      state.colorSettings = action.payload;
    },
    getAllRankingHistoryByIDSuccess(state, action) {
      state.allRankingHistoryByID = action.payload;
    },
    getAllRankingSuccess(state, action) {
      state.allRanking = action.payload;
    },
    getWheelSettingSuccess(state, action) {
      state.wheelSetting = action.payload;
    },
    getPlayerCashSuccess(state, action) {
      state.playerCash = action.payload;
    },
    getWheelPointSuccess(state, action) {
      const p = action.payload;
      let val = 0;
      if (Array.isArray(p)) {
        const f = p[0];
        val =
          typeof f === "object"
            ? f?.wheelPoint ?? f?.point ?? 0
            : Number(f) || 0;
      } else if (typeof p === "object" && p !== null) {
        val = p?.wheelPoint ?? p?.point ?? 0;
      } else {
        val = Number(p) || 0;
      }
      state.wheelPoint = val;
    },
    getGameListUrlSuccess(state, action) {
      state.gameListUrl = action.payload;
    },
    getAllProviderSuccess(state, action) {
      state.allProvider = action.payload;
    },
    getFriendInviteSuccess(state, action) {
      state.friendInvite = action.payload;
    },
    getUserAvailablePromotionSuccess(state, action) {
      state.userAvailablePromotion = action.payload;
    },
    getWithdrawSettingSuccess(state, action) {
      state.withdrawSetting = action.payload;
    },
    getBankListSuccess(state, action) {
      state.bankList = action.payload;
    },
    getTransferBankListSuccess(state, action) {
      state.transferBankList = action.payload;
    },
    getTodayPromotionReceivedSuccess(state, action) {
      state.todayPromotionReceived = action.payload;
    },
    getAllPromotionReceivedSuccess(state, action) {
      state.allPromotionReceived = action.payload;
    },
    getWebsiteSettingSuccess(state, action) {
      state.websiteSetting = action.payload;
    },
    getBannerListSuccess(state, action) {
      state.bannerList = action.payload;
    },
    getAllPopupSuccess(state, action) {
      state.allPopup = action.payload;
    },
    getTransactionHistorySuccess(state, action) {
      const payload = action.payload;
      if (payload && typeof payload === "object" && !Array.isArray(payload)) {
        state.transactionHistory = Array.isArray(payload.data)
          ? payload.data
          : [];
        const meta =
          payload.meta ||
          payload.pagination ||
          payload.info ||
          payload.metaData;
        state.transactionHistoryMeta =
          meta && typeof meta === "object" ? { ...meta } : null;
      } else {
        state.transactionHistory = Array.isArray(payload) ? payload : [];
        state.transactionHistoryMeta = null;
      }
    },
    getWithdrawHistorySuccess(state, action) {
      const payload = action.payload;
      if (payload && typeof payload === "object" && !Array.isArray(payload)) {
        state.withdrawHistory = Array.isArray(payload.data) ? payload.data : [];
        const meta =
          payload.meta ||
          payload.pagination ||
          payload.info ||
          payload.metaData;
        state.withdrawHistoryMeta =
          meta && typeof meta === "object" ? { ...meta } : null;
      } else {
        state.withdrawHistory = Array.isArray(payload) ? payload : [];
        state.withdrawHistoryMeta = null;
      }
    },
    getTMNDataSuccess(state, action) {
      state.tmnData = action.payload;
    },
    getCashbackSettingSuccess(state, action) {
      state.cashbackSetting = action.payload;
    },
    getCashbackSuccess(state, action) {
      state.cashback = action.payload;
    },
    getInviteSettingSuccess(state, action) {
      state.inviteSetting = action.payload;
    },
    getPlayerLoginLinkSuccess(state, action) {
      state.playerLoginLink = action.payload;
    },
    getPlayerBalanceSuccess(state, action) {
      state.playerBalance = action.payload;
    },
    getBetflixStatusSuccess(state, action) {
      state.betflixStatus = action.payload;
    },
    getAgentInfoSuccess(state, action) {
      state.agentInfo = action.payload;
    },
    getAgentBalanceSuccess(state, action) {
      state.agentBalance = action.payload;
    },
    getAllAdminSuccess(state, action) {
      state.allAdmin = action.payload;
    },
    getUsersListStyle1Success(state, action) {
      state.usersS1 = action.payload;
    },
    getTotalUsersSuccess(state, action) {
      state.totalUsers = action.payload;
    },
    getPromoByIDSuccess(state, action) {
      state.singlePromo = action.payload;
    },
    getAllPromoSuccess(state, action) {
      state.allPromo = action.payload;
    },
    getCreditCodeByIDSuccess(state, action) {
      state.singleCreditCode = action.payload;
    },
    getAllCreditCodeSuccess(state, action) {
      state.allCreditCode = action.payload;
    },
    getUsersByIDSuccess(state, action) {
      state.singleUsers = action.payload;
    },
    getAdminByIDSuccess(state, action) {
      state.singleAdmin = action.payload;
    },
    getTodayUsersSuccess(state, action) {
      state.todayUsers = action.payload;
    },
    getAllTransactionDWSuccess(state, action) {
      state.allTransDW = action.payload;
    },
    getByIdTransactionDWSuccess(state, action) {
      state.byIdTransDW = action.payload;
    },
    // added simple set/clear reducers expected elsewhere
    setPlayerBalance(state, action) {
      state.playerBalance = action.payload;
    },
    clearPlayerBalance(state) {
      state.playerBalance = [];
    },
    setWheelPoint(state, action) {
      const p = action.payload;
      let val = 0;
      if (Array.isArray(p)) {
        const f = p[0];
        val =
          typeof f === "object"
            ? f?.wheelPoint ?? f?.point ?? 0
            : Number(f) || 0;
      } else if (typeof p === "object" && p !== null) {
        val = p?.wheelPoint ?? p?.point ?? 0;
      } else {
        val = Number(p) || 0;
      }
      state.wheelPoint = val;
    },
    clearWheelPoint(state) {
      state.wheelPoint = 0;
    },
    setPlayerCash(state, action) {
      state.playerCash = action.payload;
    },
    clearPlayerCash(state) {
      state.playerCash = [];
    },
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    clearCurrentUser(state) {
      state.currentUser = null;
    },
    setAllPromo(state, action) {
      state.allPromo = action.payload;
    },
    // Hot Games reducers
    getHotGamesRequest(state) {
      state.hotGamesLoading = true;
      state.hotGamesError = null;
    },
    getHotGamesSuccess(state, action) {
      state.hotGames = action.payload;
      state.hotGamesLoading = false;
      state.hotGamesError = null;
    },
    getHotGamesFailure(state, action) {
      state.hotGamesLoading = false;
      state.hotGamesError = action.payload;
    },
    setMarketingActivitiesActive(state, action) {
      state.marketingActivitiesActive = action.payload || [];
    },
    setMarketingSubmitResult(state, action) {
      state.marketingSubmitResult = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  setPlayerBalance,
  clearPlayerBalance,
  setWheelPoint,
  clearWheelPoint,
  setPlayerCash,
  clearPlayerCash,
  setCurrentUser,
  clearCurrentUser,
  setAllPromo,
  setMarketingActivitiesActive,
  setMarketingSubmitResult,
} = slice.actions;
// Re-export async thunks
export * from "./userActions";
